// extracted by mini-css-extract-plugin
export default {"productGrid":"hka-z","centerLink":"ika-z","productSection":"jka-z","item":"kka-z","ctaButton":"lka-z"};